import React from 'react';
import styled from 'styled-components';
import Icon from "../../basic/Icon/Icon.js";
export var ButtonText = styled.span.withConfig({
  componentId: "CL__sc-120h3ar-0"
})(["color:inherit;display:inline-block;text-shadow:none;font:inherit;font-weight:600;font-family:var(--body-text-typeface);pointer-events:none;vertical-align:middle;"]);
var getButtonMargin = (iconPosition, size) => {
  var marginValue = 'var(--spacing-1)';
  if (size === 'large') marginValue = '9px';
  if (size === 'small') marginValue = '3px';
  return {
    property: "margin-".concat(iconPosition === 'right' ? 'left' : 'right'),
    value: "".concat(marginValue)
  };
};

// prettier-ignore
export var ButtonIcon = styled(Icon).withConfig({
  componentId: "CL__sc-120h3ar-1"
})(["display:inline-block;text-shadow:none;pointer-events:none;vertical-align:middle;", ""], _ref => {
  var {
    iconPosition,
    size
  } = _ref;
  return iconPosition ? "\n      &:not(:only-child) {\n        ".concat(getButtonMargin(iconPosition, size).property, ": ").concat(getButtonMargin(iconPosition, size).value, ";\n      }\n    ") : "";
});
var InnerContent = _ref2 => {
  var {
    children,
    icon,
    iconPosition = 'left',
    size = 'medium'
  } = _ref2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, icon && iconPosition === 'left' && /*#__PURE__*/React.createElement(ButtonIcon, {
    color: "currentColor",
    component: icon,
    iconPosition: iconPosition,
    size: size
  }), children && /*#__PURE__*/React.createElement(ButtonText, null, children), icon && iconPosition === 'right' && /*#__PURE__*/React.createElement(ButtonIcon, {
    color: "currentColor",
    component: icon,
    iconPosition: iconPosition,
    size: size
  }));
};
export default InnerContent;